import LazyLoad from "vanilla-lazyload";

const lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy"
});

$(document).ready(function() {
  lazyLoadInstance.update();
});
